import { z } from "zod";

export const INTERESTS = [
  "Lighting & scene controls",
  "Climate / HVAC controls",
  "Guest room controls",
  "Energy management",
  "Occupancy intelligence",
  "Software & monitoring",
  "Integrations",
  "Not sure yet",
] as const;

// Awaiting the option lists from design; each select shows its placeholder until filled.
export const PROJECT_TYPES: readonly string[] = [];
export const GUEST_ROOM_BANDS: readonly string[] = [];
export const TIMELINES: readonly string[] = [];

export const QuoteValues = z.object({
  firstName: z.string().min(1, "Enter your first name"),
  lastName: z.string().min(1, "Enter your last name"),
  email: z.email("Enter a valid email address"),
  phone: z.string(),
  company: z.string(),
  role: z.string(),
  projectName: z.string().min(1, "Enter the property or project name"),
  location: z.string(),
  projectType: z.string(),
  guestRooms: z.string(),
  timeline: z.string(),
  interests: z.array(z.string()).min(1, "Choose at least one"),
  message: z.string(),
});

export type QuoteValues = z.infer<typeof QuoteValues>;
